import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Language } from "../../i18n/translations";
import { LanguageState } from "./types";
import { getBrowserLanguage, isLanguageSupported } from "../../i18n/translations";

// Get initial language from localStorage or browser
const getInitialLanguage = (): Language => {
  const savedLanguage = localStorage.getItem("appLanguage");
  if (savedLanguage && isLanguageSupported(savedLanguage)) {
    return savedLanguage as Language;
  }
  return getBrowserLanguage();
};

const initialState: LanguageState = {
  current: getInitialLanguage(),
};

export const languageSlice = createSlice({
  name: "language",
  initialState: { value: initialState },
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.value.current = action.payload;
      // Persist to localStorage
      localStorage.setItem("appLanguage", action.payload);
    },
    resetLanguage: (state) => {
      const defaultLanguage = getBrowserLanguage();
      state.value.current = defaultLanguage;
      localStorage.setItem("appLanguage", defaultLanguage);
    },
  },
});

export const { setLanguage, resetLanguage } = languageSlice.actions;
export default languageSlice.reducer;
